<template>
  <div v-if="feature">
    <router-link :to="{
        name: 'Feature',
        params: { uuid: feature.id }
      }">
        {{ feature.name }}
    </router-link>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  props:["featureIdentifier"],
  data(){
    return {
      features: []
    }
  },
  apollo: {
    features: {
      query: gql`query findfeature($source_identifier: String){
        features(where: {source_identifier: {_eq: $source_identifier}}, limit: 1){
          id
          name
        }
      }`,
      variables(){
        return {
          source_identifier: this.featureIdentifier,
        }
      }
    }
  },
  computed:{
    feature(){
      return this.features[0];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PopupContent.vue